import React, { Component } from "react";
import { SERVER_TIMEOUT } from "../constants";
import PolicyCards from "./PolicyCards";
import { PolicyType, SendWSCommand, WSCommandType } from "../types";
import "./Prompts.css";

type PresidentLegislativePromptProps = {
  policyOptions: PolicyType[];
  sendWSCommand: SendWSCommand;
  /** Name of the Chancellor who receives the remaining policies. */
  chancellor?: string;
};

type PresidentLegislativePromptState = {
  selection: number | undefined;
  waitingForServer: boolean;
};

class PresidentLegislativePrompt extends Component<
  PresidentLegislativePromptProps,
  PresidentLegislativePromptState
> {
  timeoutID: NodeJS.Timeout | undefined;

  constructor(props: PresidentLegislativePromptProps) {
    super(props);
    this.state = {
      selection: undefined,
      waitingForServer: false,
    };
    this.onButtonClick = this.onButtonClick.bind(this);
  }

  onButtonClick() {
    if (this.state.selection === undefined) {
      return;
    }
    // Lock the button so that it can't be pressed multiple times.
    this.setState({ waitingForServer: true });
    this.timeoutID = setTimeout(() => {
      this.setState({ waitingForServer: false });
    }, SERVER_TIMEOUT);

    // Contact the server using provided method.
    this.props.sendWSCommand({
      command: WSCommandType.REGISTER_PRESIDENT_CHOICE,
      choice: this.state.selection,
    });
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutID);
  }

  render() {
    return (
      <div className="pp">
        <div className="pp-kicker">Legislative session · you are President</div>
        <div className="pp-title">Discard one policy</div>
        <div className="pp-text">
          The other two go to{" "}
          <strong>{this.props.chancellor ? "Chancellor " + this.props.chancellor : "the Chancellor"}</strong>, who
          enacts one of them. Nobody sees what you discard.
        </div>
        <PolicyCards
          policies={this.props.policyOptions}
          selection={this.state.selection}
          onSelect={(index) => this.setState({ selection: index })}
          selectedTag="Discard"
          selectedTagKind="discard"
          disabled={this.state.waitingForServer}
        />
        <div className="pp-actions">
          <button
            id="prompt-button"
            className="gold-button pp-btn"
            disabled={this.state.selection === undefined || this.state.waitingForServer}
            onClick={this.onButtonClick}
          >
            <span className="gold-label">DISCARD</span>
          </button>
        </div>
      </div>
    );
  }
}

export default PresidentLegislativePrompt;
